 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import TITLE from '@/components/title'
 import COPYRIGHT from '@/components/copyright'
 import DEDICATION from '@/components/dedication'
 import TOC from '@/components/toc'
 import PREFACE from '@/components/preface'
 import GUIDE from '@/components/guide'
 import ABBREVIATIONS from '@/components/abbreviations'
 import PUBLISH from '@/components/publish'
 import ADDRESS from '@/components/address'
 import PART1 from '@/components/part1'
 import CHAP1 from '@/components/chap1'
 import CHAP2 from '@/components/chap2'
 import CHAP201 from '@/components/chap2-01'
 import CHAP3 from '@/components/chap3'
 import CHAP301 from '@/components/chap3-01'
 import CHAP4 from '@/components/chap4'
 import CHAP5 from '@/components/chap5'
 import CHAP6 from '@/components/chap6'
 import CHAP7 from '@/components/chap7'
 import CHAP8 from '@/components/chap8'
 import CHAP9 from '@/components/chap9'
 import CHAP10 from '@/components/chap10'
 import CHAP11 from '@/components/chap11'
 import CHAP12 from '@/components/chap12'
 import CHAP13 from '@/components/chap13'
 import CHAP14 from '@/components/chap14'
 import CHAP15 from '@/components/chap15'
 import CHAP16 from '@/components/chap16'
 import CHAP17 from '@/components/chap17'
 import CHAP18 from '@/components/chap18'
 import CHAP19 from '@/components/chap19'
 import CHAP1901 from '@/components/chap19-01'
 import CHAP20 from '@/components/chap20'
 import CHAP21 from '@/components/chap21'
 import CHAP22 from '@/components/chap22'
 import CHAP23 from '@/components/chap23'
 import CHAP24 from '@/components/chap24'
 import CHAP25 from '@/components/chap25'
 import CHAP26 from '@/components/chap26'
 import PART2 from '@/components/part2'
 import PART201 from '@/components/part2-01'
 import BIB from '@/components/bib'
 import APP from '@/components/app'
 import INDEX from '@/components/index'
 import ABT from '@/components/abt'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/toc",
 			"name" : "toc",
 			"component" : TOC
 		},
 		{
 			"path" : "/preface",
 			"name" : "preface",
 			"component" : PREFACE
 		},
 		{
 			"path" : "/guide",
 			"name" : "guide",
 			"component" : GUIDE
 		},
 		{
 			"path" : "/abbreviations",
 			"name" : "abbreviations",
 			"component" : ABBREVIATIONS
 		},
 		{
 			"path" : "/publish",
 			"name" : "publish",
 			"component" : PUBLISH
 		},
 		{
 			"path" : "/address",
 			"name" : "address",
 			"component" : ADDRESS
 		},
 		{
 			"path" : "/part1",
 			"name" : "part1",
 			"component" : PART1
 		},
 		{
 			"path" : "/chap1",
 			"name" : "chap1",
 			"component" : CHAP1
 		},
 		{
 			"path" : "/chap2",
 			"name" : "chap2",
 			"component" : CHAP2
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js